<template>
    <section>
        <!-- <transition-group name="modal"> -->
        <div class="modal-mask">
            <div class="modal-wrapper _modalWrapper_">
                <div class="modal-container flexContainer">
                    <div class="modalBody">
                        <img src="../../../assets/croix.png" width="20" height="20" class="cross fright abs pointer" @click="close" />
                        <div class="modalContent txtCenter">
                            <h2 class="ff-light">{{ $t("favorite.title") }}</h2>
                            <p>{{ $t("favorite.name") }}</p>
                            <input id="favoriteName" placeholder="Favorite name" type="text" v-on:keyup.enter="save" v-model="name" />
                        </div>
                        <div>
                            <button class="btn block pointer center" @click="save">{{ $t("favorite.save") }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- </transition-group> -->
    </section>
</template>

<script>
import httpService from "../../service";
import { mapActions, mapGetters } from "vuex";

export default {
    // props: {
    //     favorite: {type: Object}
    // },
    data() {
        return {
            name: ""
        };
    },
    computed: {
        ...mapGetters("gui/menubar", {
            isActive: "isActive"
        })
    },
    created() {},
    mounted() {
        document.getElementById("favoriteName").focus();
    },
    methods: {
        ...mapActions("plano/data", {
            listFavorites: "listFavorites"
        }),

        ...mapActions("gui/menubar", {
            addMenuItemActive: "addMenuItemActive"
        }),

        close() {
            this.$parent.favorite = null;
        },
        save() {
            let favorite = this.$parent.favorite;
            let svgStr = favorite.svg.outerHTML.replace(new RegExp("&nbsp;", "g"), ",");

            let fav = {
                type: favorite.type,
                component: this.assign(favorite.component),
                size: favorite.size,
                hookInverse: favorite.hookInverse
            };
            let objSave = {
                svg: svgStr,
                name: this.name,
                content: fav
            };

            httpService.post("/favorites", JSON.stringify(objSave)).then(response => {
                // Vue.toast('ENREGISTREMENT DANS FAVORIS REUSSI', {
                //     id: 'my-toast',
                //     className: ['my-toast', 'toast-warning', 'flexContainer'],
                //     horizontalPosition: 'right',
                //     verticalPosition: 'bottom',
                //     mode: 'queue'
                // })
                this.$parent.favorite = null;
                this.listFavorites();
                let idMenu = "menu_plano_massmarket";
                let id = "menuitem_plano_massmarket_fav";
                if (!this.isActive(idMenu, id)) {
                    this.addMenuItemActive({ idMenu, id });
                }
                // this.setShowModalFavorite(false)
                //                        this.$emit('closeModal', false)
            });

            console.log(objSave, "======");
        }
    }
};
</script>

<style scoped lang="scss">
._selectedCampaign,
._selectedZone {
    color: #0000f0;
    font-weight: bold;
}

/* height firefox modal */
._modalWrapper_ {
    height: 100%;
}

/* end height */
.modal-mask {
    position: fixed;
    z-index: 250;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: table;
    transition: opacity 0.3s ease;
    .cross {
        top: 10px;
        right: 10px;
        z-index: 2;
    }
}

.modal-wrapper {
    display: table-cell;
    vertical-align: middle;
    .modal-container {
        width: 100%;
        height: 100%;
        margin: 0px auto;
        padding: 20px 30px;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
        transition: all 0.3s ease;
        font-family: Helvetica, Arial, sans-serif;
        position: relative;
        .logoContainer {
            width: 880px;
            .brandLogo {
                border-radius: 0.7rem;
                height: 110px;
                background-color: white;
                width: 100%;
                img {
                    margin: auto;
                }
            }
        }
        .modalBody {
            background: #fff;
            width: 500px;
            height: 220px;
            border-radius: 4px;
            padding: 15px;
            margin: auto;
            position: relative;
            .modalContent {
                h2 {
                    font-size: 1.6rem;
                }
                p {
                    font-size: 1.4rem;
                    margin: 30px 0;
                }
                #favoriteName {
                    background-color: transparent;
                    border: none;
                    border-bottom: 1px solid #343434;
                    margin-bottom: 30px;
                    font-family: Roboto;
                    font-size: 14px;
                    &:focus {
                        outline: none;
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// AddFavorite.vue?71dcb2a0